/* lib/haptics.js — EL TIC HÁPTICO DE LA CASA. UNA sola copia.
 *
 * Nació dentro de `components/MobileBottomNav.js` (G-F2, PR #193) como el tic
 * que se siente al cruzar de ícono arrastrando por la píldora. COS-I necesita
 * EXACTAMENTE ese tic —mismo plugin, mismo peso, mismos cinturones— al cambiar
 * de pestaña con el swipe, y la doctrina del repo es la misma que la de los
 * gestos (`useEdgeSwipeBack.js`): cero copias, quien lo quiera lo importa de
 * aquí. El mecanismo se MUDÓ tal cual; ni el gate, ni el import dinámico, ni el
 * peso, ni el fire-and-forget cambiaron una coma. La píldora sigue llamándolo
 * en el mismo punto y con el mismo nombre local (`hapticCrossTick`).
 *
 * LOS TRES CINTURONES (los originales, intactos):
 *
 *   1. GATE app-only + shell nativo real, con el mismo trío que
 *      offline/networkVerdict.js: `IS_APP_BUILD` y `Capacitor.isNativePlatform()`
 *      evaluado POR LLAMADA. El plugin trae implementación WEB (usa la Vibration
 *      API), y ahí un gesto que zumba sería un estreno que nadie pidió: en web
 *      ni se importa.
 *
 *   2. IMPORT DINÁMICO Y CACHEADO, patrón tokenStore/networkVerdict: webpack lo
 *      parte en un chunk que el bundle web jamás pide. Se guarda la PROMESA del
 *      módulo, no el plugin pelado — `Haptics` es un proxy de `registerPlugin`
 *      que convierte cualquier acceso a propiedad (incluido `then`) en llamada
 *      nativa, y devolverlo como valor de resolución colgaría la promesa para
 *      siempre (el hang de boot de F4.2c).
 *
 *   3. FIRE-AND-FORGET Y A PRUEBA DE TODO: nadie espera el tic, y si el plugin
 *      falta, truena o el bridge no contesta, el gesto sigue completo SIN
 *      vibración. Jamás un error al usuario por una vibración.
 *
 * Que `Light` sea el peso correcto y no un `Medium` sólo lo puede firmar el
 * iPhone: es una línea para cambiarlo, y ahora es UNA para los dos gestos.
 */
import { IS_APP_BUILD } from './buildTarget';

const HAPTIC_IMPACT_FALLBACK = 'LIGHT';

let hapticsModulePromise = null;

export function hapticsEnabled() {
  return IS_APP_BUILD
    && typeof window !== 'undefined'
    && !!window.Capacitor?.isNativePlatform?.();
}

/** Un impacto LIGERO, fire-and-forget. No-op fuera del shell nativo. */
export function hapticImpactLight() {
  if (!hapticsEnabled()) return;
  try {
    if (!hapticsModulePromise) hapticsModulePromise = import('@capacitor/haptics');
    hapticsModulePromise
      .then((mod) => mod.Haptics.impact({ style: mod.ImpactStyle?.Light || HAPTIC_IMPACT_FALLBACK }))
      .catch(() => { /* sin vibración; el gesto ya está completo sin ella */ });
  } catch (e) {
    // Ídem: un plugin ausente no puede costar un gesto.
  }
}

/** Sólo para tests: devuelve el cacheo del módulo a su estado de arranque. */
export function __resetHapticsForTests() {
  hapticsModulePromise = null;
}
